module.exports = __webpack_public_path__ + "img/popup-entry-bg-1.8815b21c.png";